import http from '../../../utils/tools/http';
import {
  CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_BEGIN,
  CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_SUCCESS,
  CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_FAILURE,
  CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchNoLoginInputToShopcar(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = http.post({ url: "/datastore/Order/NoLoginInputToShopcar", params: args });
      doRequest.then(
        (res) => {
          dispatch({
            type: CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchNoLoginInputToShopcarError() {
  return {
    type: CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchNoLoginInputToShopcarPending: true,
        fetchNoLoginInputToShopcarError: null,
      };

    case CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchNoLoginInputToShopcarPending: false,
        fetchNoLoginInputToShopcarError: null,
      };

    case CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchNoLoginInputToShopcarPending: false,
        fetchNoLoginInputToShopcarError: action.data.error,
      };

    case CENTER_FETCH_NO_LOGIN_INPUT_TO_SHOPCAR_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchNoLoginInputToShopcarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/center/redux/fetchNoLoginInputToShopcar.js